/**
 * ScopeNote (US-17-GR-35)
 *
 * Compact "data scope" badge for metrics built on the UsageEvent telemetry
 * rail, which does not cover every surface (016-US-08 / AdminReportsModels).
 * Same native-tooltip pattern as EstimateBadge (RetentionEngagementPanel.tsx)
 * and AbbrLabel: a short always-visible label plus a title/aria-label
 * carrying the full caveat, so the detail survives keyboard focus and
 * screen readers without a tooltip library.
 */

interface ScopeNoteProps {
  /** Full caveat text, exposed via title (hover) and aria-label (screen reader). */
  explanation: string;
  /** Visible label. Defaults to "Data scope". */
  label?: string;
  className?: string;
}

export function ScopeNote({ explanation, label = 'Data scope', className }: ScopeNoteProps) {
  return (
    <span
      title={explanation}
      aria-label={`${label}: ${explanation}`}
      tabIndex={0}
      className={[
        'inline-flex items-center px-1.5 py-0.5 rounded border border-sky-500/30 bg-sky-500/10 text-[10px] font-medium text-sky-300 cursor-help',
        className ?? '',
      ].join(' ')}
    >
      {label}
    </span>
  );
}

export default ScopeNote;
